import { Controller } from 'stimulus';

export default class SwitchController extends Controller {
  static targets = ['input'];

  connect() {
    this.inputTarget.addEventListener('change', this.onChange);
    this.onChange();
  }

  disconnect() {
    this.inputTarget.removeEventListener('change', this.onChange);
  }

  onChange = () => {
    const { checked } = this.inputTarget;

    if (checked) {
      this.element.classList.add('active');
    } else {
      this.element.classList.remove('active');
    }

    this.element.dispatchEvent(new CustomEvent('switch', { detail: checked }));
  };
}
